var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"size":_vm.size,"type":_vm.type,"icon":_vm.icon,"disabled":_vm.disabled,"loading":_vm.loading},on:{"click":_vm.handleClick}},[_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10fc7266","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/KtButton.vue
// module id = null
// module chunks = 